<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
input,select{
  border: none;
}
::-webkit-input-placeholder {
     color:rgba(204,204,204,1);
 }
:-moz-placeholder {/* Firefox 18- */
     color:rgba(204,204,204,1);
 }
::-moz-placeholder{/* Firefox 19+ */
     color:rgba(204,204,204,1);
 }
:-ms-input-placeholder {
     color:rgba(204,204,204,1);
}
 .yd-tab-nav-item{
  font-size: 17px!important;
  line-height: 17px!important;
  padding: 16px 0!important;
  color: #666666;
}
.yd-tab-nav:after{
  border: none!important;
} 
.yd-tab-nav-item:not(:last-child):after{
  border: none!important;
}
.yd-tab-nav{
  color: #D61819!important;
 
}
.yd-tab-nav-item{
   background:rgba(247,247,249,1)!important;
}
.yd-slider-pagination-item{
  margin: 0 5px!important;
}
.yd-slider-pagination{
  bottom: 112px!important;
}
.yd-slider-pagination-item{
  background-color: white;
}
.yd-slider-pagination-item-active{
  background-color: #ff0005;
}
.yd-list-donetip{
  padding: .5rem 0;
}
#show img{
    width: 320px!important;
}
#content img{
   width: 320px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue